import {
	type BuilderCtx,
	CAP,
	type Collection,
	placeDistances,
} from './shared.ts'

// "Good for today" — weather-suited ideas that are also close by. It assumes
// you're at a loose end, so it only surfaces places within 25 miles (a walk in
// the next county is no use on a whim) and orders them nearest-first. Needs
// both a location and a forecast, so it sits out until we have them.
export const buildWeatherRow = ({
	activities,
	origin,
	weather,
	placeName,
}: BuilderCtx): Collection | null => {
	if (!weather || !origin) return null

	const suited = placeDistances(activities, origin)
		.filter((p) => p.miles <= 25)
		.filter(
			(p) =>
				p.activity.weatherSuits.includes('any') ||
				p.activity.weatherSuits.some((w) => weather.suits.includes(w)),
		)
		.map((p) => p.activity)
		.slice(0, CAP)

	return {
		key: 'weather',
		title: weather.headline,
		subtitle: placeName
			? `${weather.detail} • ${placeName} · nearby & suits today`
			: `${weather.detail} · nearby & suits today`,
		activities: suited,
		seeAll: {
			where: 'place',
			maxDistanceMiles: 25,
			weathers: weather.suits,
		},
	}
}
